import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.plugins.unregister(ChartDataLabels)
Chart.defaults.global.defaultFontSize = 11
Chart.defaults.global.defaultFontFamily = "Helvetica"

import axios from 'axios'
import { Controller } from "stimulus"

var percent = 0;
var mode = "";
var message = "";
var chart;

export default class extends Controller {
  static targets = ["percentDisplay", "messageDisplay"]

  connect() {
    percent = this.element.dataset.percent;
    mode = this.element.dataset.mode;
    message = this.element.dataset.message;
    this.setupChart();
    this.updateDisplay();
    this.updateChartDisplay();
    this.updateButtons();
  }

  setupChart() {
    var ctx = document.getElementById("homestats-chart");
    chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: ["", ""],
        datasets: [{
          label: '',
          data: [percent, 100 - percent],
          backgroundColor: [
            '#FF6E6E',
            '#FAFAFA'
          ],
          borderWidth: 0
        }]
      },
      options: {
        legend: {
          labels: {
            fontFamily: 'Roboto',
            boxWidth: 0,
            fontSize: 16,
            fontColor: '#FF6E6E'
          },
          display: false
        },
        tooltips: {
          enabled: false
        },
        hover: { mode: null },
        cutoutPercentage: 75,
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI
      }
    });
  }

  updateDisplay() {
    this.percentDisplayTarget.innerText = `${percent}%`;
    this.messageDisplayTarget.innerText = message;
  }

  updateChartDisplay() {
    let color = ""
    if (percent > 66)
      color = "#00FF00"
    else if (percent > 33)
      color = "#FFA500"
    else color = "#FF0000"
    chart.data.datasets[0].backgroundColor = [color, "#FAFAFA"]
    const tmp = percent > 100 ? 100 : percent
    chart.data.datasets[0].data = [tmp, 100 - tmp];
    chart.update();
  }

  updateButtons() {
    const buttons = this.element.querySelectorAll('.button');
    buttons.forEach(button => {
      button.classList.add('color-group1');
      button.classList.remove('color-group3');
      if (button.dataset.mode == mode)
        button.classList.add('color-group3');
    });
  }

  changeMode(e) {
    mode = e.target.dataset.mode;
    this.updateButtons();

    let url = `${this.element.dataset.path}?mode=${mode}`
    axios.get(url).then(response => {
      percent = response.data.percent;
      message = response.data.message;
      mode = response.data.mode;

      this.updateDisplay();
      this.updateChartDisplay();
    });
  }

}